<!-- TODO restructure the conditional logic, removing the asyncs in the children break the component -->
<div
  (click)="showThinBar = !showThinBar"
  *ngIf="isStaging && showThinBar"
  class="demo-thin-bar"
>
  Staging Environment
</div>

<div
  *ngIf="!(user$ | async) || !(user$ | async).loaded; else app"
  class="loader-container"
>
  <div class="loader">
    <boma-progress-spinner
      [loaded]="(user$ | async)?.error"
    ></boma-progress-spinner>
    <p *ngIf="!(user$ | async)?.error; else error" class="text-center mt-5"></p>
    <p>{{ authStatus }}</p>
  </div>
</div>

<ng-template #error>
  <ng-container
    *ngIf="
      (user$ | async)?.error?.status == 403 ||
        (user$ | async)?.error?.status == 403;
      else serverError
    "
  >
    <div
      (click)="onLayoutClick()"
      [attr.data-theme]="colorScheme"
      [class]="colorScheme === 'light' ? menuTheme : 'white'"
      [ngClass]="{
        'layout-overlay': menuMode === 'overlay',
        'layout-static': menuMode === 'static',
        'layout-slim': menuMode === 'slim',
        'layout-sidebar-dim': colorScheme === 'dim',
        'layout-sidebar-dark': colorScheme === 'dark',
        'layout-overlay-active': overlayMenuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-static-inactive':
          staticMenuDesktopInactive && menuMode === 'static',
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': !ripple
      }"
      class="layout-wrapper"
    >
      <div class="layout-content-wrapper">
        <!--TODO finish up the horizontal bar to include all values-->

        <div class="realtive top-0 z-5 shadow-3 border-none">
          <website-menu
            (contextChanged)="contextChanged($event)"
            (handleMenuButtonClick)="onMenuButtonClick($event)"
            (logout)="logout()"
            [activeLocationId]="activeLocationId"
            [locations]="locations"
            [menuItems]="horizontalMenuItems"
            [module]="'supplier'"
            [profile]="user$ | async"
            [username]="username"
            scope="portal"
            [checkedUsername]="checkedUsername"
            [topBarNotificationMenuActive]="topBarNotificationMenuActive"
          ></website-menu>
        </div>

        <div *ngIf="loaded$ | async" class="layout-content">
          <!--AUTO HANDLED IN USER STATE -->
          <p-messages severity="warn">
            <ng-template pTemplate>
              <span class="custom-message">
                <ng-container>
                  There was a problem retrieving your user, try again,<br />if
                  the problem persists please contact support&#64;boma.today
                </ng-container>
              </span>
            </ng-template>
          </p-messages>
        </div>

        <p-button
          (click)="clearLocalStorage()"
          icon="material-icons-round mi-delete-sweep"
          label="Try Again"
          styleClass="p-button-danger p-button-outlined"
        ></p-button>
      </div>
    </div>
  </ng-container>

  <ng-template #serverError>
    <h3>There seems to be some trouble contacting, the Boma Server.</h3>
    <p>
      Please check with your IT department, and check your internet
      connectivity. If the problem persists please have IT contact
      support&#64;boma.today.
    </p>
    <br />
    <p-button
      (click)="clearLocalStorage()"
      icon="material-icons-round mi-delete-sweep"
      label="Try Again"
      styleClass="p-button-danger p-button-outlined"
    ></p-button>
  </ng-template>
</ng-template>

<ng-template #app>
  <div
    (click)="onLayoutClick()"
    [attr.data-theme]="colorScheme"
    [class]="colorScheme === 'light' ? menuTheme : 'white'"
    [ngClass]="{
      'layout-overlay': menuMode === 'overlay',
      'layout-static': menuMode === 'static',
      'layout-slim': menuMode === 'slim',
      'layout-sidebar-dim': colorScheme === 'dim',
      'layout-sidebar-dark': colorScheme === 'dark',
      'layout-overlay-active': overlayMenuActive,
      'layout-mobile-active': staticMenuMobileActive,
      'layout-static-inactive':
        staticMenuDesktopInactive && menuMode === 'static',
      'p-input-filled': inputStyle === 'filled',
      'p-ripple-disabled': !ripple
    }"
    class="layout-wrapper"
  >
    <!-- SIDEBAR -->
    <boma-portal-menu
      (handleMenuClick)="onMenuClick()"
      (handleMenuHoverActive)="onSetMenuHoverActive()"
      (handleMenuHoverActiveFalse)="onSetMenuHoverActiveFalse()"
      (handleStaticMenuMobileActiveFalse)="onSetStaticMenuMobileActiveFalse()"
      (handleUnblockBodyScroll)="unblockBodyScroll()"
      [isDesktop]="isDesktop()"
      [isMenuHoverActive]="isMenuHoverActive()"
      [isMobile]="isMobile()"
      [isSlim]="isSlim()"
      [menuItems]="showHorizontalMenu ? horizontalMenuItems : menuItems"
      [isHorizontal]="showHorizontalMenu"
    ></boma-portal-menu>

    <div class="layout-content-wrapper">
      <div class="realtive top-0 z-5 shadow-3 border-none">
        <!--Portal icons, hamburger and context changer-->
        <website-menu
          (contextChanged)="contextChanged($event)"
          (handleMenuButtonClick)="onMenuButtonClick($event)"
          (logout)="logout()"
          [activeLocationId]="activeLocationId"
          [locations]="locations"
          [menuItems]="horizontalMenuItems"
          [module]="'supplier'"
          [profile]="user$ | async"
          [username]="username"
          scope="portal"
          [checkedUsername]="checkedUsername"
          [topBarNotificationMenuActive]="topBarNotificationMenuActive"
        ></website-menu>

        <!-- THE THING THAT CONTAINS BREADCRUMBS AND ACTIONS -->
        <boma-portal-top-bar
          (changeDirectory)="contextChanged($event)"
          (handleMenuButtonClick)="onMenuButtonClick($event)"
          (handleRightMenuClick)="onRightMenuClick($event)"
          (handleSearchClick)="onSearchClick($event)"
          (handleTopbarUserMenuButtonClick)="
            onTopbarUserMenuButtonClick($event)
          "
          (handleTopbarNotificationMenuButtonClick)="
            onTopbarNotificationMenuButtonClick($event)
          "
          [customMenuActions]="topBarCustomMenuActions"
          [organizations]="userBusinessAccounts$ | async"
          [topBarNotificationMenuActive]="topBarNotificationMenuActive"
          [topbarUserMenuActive]="topbarUserMenuActive"
          [user]="user$ | async"
        ></boma-portal-top-bar>
      </div>

      <div *ngIf="loaded$ | async" class="layout-content">
        <router-outlet></router-outlet>
      </div>

      <boma-portal-footer
        [darkMode]="(this.style$ | async)?.colorScheme"
      ></boma-portal-footer>
    </div>

    <!--Right  hover out menu -->
    <!--    <boma-app-right-menu></boma-app-right-menu>-->

    <div class="layout-mask modal-in"></div>
    <p-toast position="bottom-right"></p-toast>
  </div>
</ng-template>
